<template>
  <div class="locations-links flex flex-wrap my-110">
    <vz-button
      big
      outline
      v-for="link in links"
      :to="{path: link.to}"
      target="_blank"
      variant="lt-gray"
      class="mb-20 mr-20"
    >
      {{ link.title }}
    </vz-button>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useCityStore } from '~/stores/city'
import { PublicLink } from '~/types/public'

const { from, rclCityList } = storeToRefs(useCityStore())

const links = computed(() => {
  if ((+from.value.population) < 500000) {
    return []
  }
  const list = [] as PublicLink[]
  rclCityList.value.forEach((city) => {
    if (from.value.guid !== city.guid) {
      list.push({
        title: `${from.value.name} - ${city.name}`,
        to: `/order/create/${from?.value?.translit}_${city.translit}/`
      })
    }
  })
  return list
})
</script>

<style lang="scss" scoped>
.locations-links {
  .vz-button {
    border-color: $border-gray;
    font-size: $fs-14;
    min-height: 46px !important;
  }
}
</style>

